
require('jquery-form');

var $ = require('jquery');

var Vue = require('vue');
var VueRouter = require('vue-router');

Vue.use(VueRouter);

var router = new VueRouter();

var service = require('./QuizService');

router.map({

    '/': {
        component: require('./start')
    },

    '/quiz': {
        component: require('./quiz'),
        hasId: true
    },

    '/questionnaire': {
        component: require('./questionnaire'),
        hasId: true
    },

    '/playlist': {
        component: require('./playlist'),
        hasId: true
    },

    '/linkedin': {
        component: require('./linkedin'),
        hasId: true
    },

    '/form': {
        component: require('./form'),
        hasId: true
    }
});

router.beforeEach(function (transition) {
    if (transition.to.hasId) {
        if (transition.to.path !== '/quiz') {
            // Make sure we have an id
            if (!service.getId()) {
                transition.redirect('/');
            } else {
                transition.next();
            }
        } else {

            $.ajax('/getnewid', {
                'data': {},
                'type': 'GET',
                'dataType': 'json',
                success: function(response) {
                    service.setId(response.id);
                    transition.next();
                },
                complete: function () {

                }
            });

           // $.ajax({ /*configs*/ }).then(function (response) {

           //     service.setId(response.id);
           //     transition.next();

          //  });

        }
    }
    else {
        transition.next();
    }
});

router.redirect({
    //'/': '/quiz'
});

var App = Vue.extend({});

router.start(App, '#app');

(function() {
    var lastTime = 0;
    var vendors = ['ms', 'moz', 'webkit', 'o'];
    for(var x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
        window.requestAnimationFrame = window[vendors[x]+'RequestAnimationFrame'];
        window.cancelAnimationFrame = window[vendors[x]+'CancelAnimationFrame']
                                   || window[vendors[x]+'CancelRequestAnimationFrame'];
    }

    if (!window.requestAnimationFrame)
        window.requestAnimationFrame = function(callback, element) {
            var currTime = new Date().getTime();
            var timeToCall = Math.max(0, 16 - (currTime - lastTime));
            var id = window.setTimeout(function() { callback(currTime + timeToCall); },
              timeToCall);
            lastTime = currTime + timeToCall;
            return id;
        };

    if (!window.cancelAnimationFrame)
        window.cancelAnimationFrame = function(id) {
            clearTimeout(id);
        };
}());

Vue.filter('millis', function (millis) {
    if (!millis) {
        return '00:00:00';
    }

    var minutes = Math.floor(millis / 60000);
    millis = millis % 60000;

    var seconds = Math.floor(millis / 1000);
    millis = millis % 1000;

    millis = Math.floor(millis / 10);

    return '<span class="timerfix">' + '0' + minutes + ":" + (seconds < 10 ? '0' : '') + seconds + ':</span>' + '<span style="display: inline-block; width: 50px;">' + (millis < 10 ? '0' : '&nbsp;') + millis + '</span>';
});


jQuery(function ($) {

    $('.closeopen').click(function() {
        $('.socialQuiz').toggleClass('active');
        $('.btn').toggleClass('active');
        $('.formwrap').toggleClass('active');
        $('.animateQuiz').toggleClass('active');
        $('.closeopen').toggleClass('active');
        $('.aboutWrapper').toggleClass('active');
        $('.overlay').toggleClass('active');
        $('.startText').toggleClass('active');
        $('.quiztext').toggleClass('active');
        $('.aboutskew').toggleClass('active');
        $('.badgewrapper').toggleClass('active');
        $('.wave').toggleClass('active');
        $('.socialStart').toggleClass('active');
        $('.form').toggleClass('active');
        $('.aboutInnerWrap').toggleClass('active');

    });

        $('.socialbtnMobile').click(function() {
        $('.socialAbout').toggle();

    });


    $('.tweet').click(function(e){
      e.preventDefault();
      var loc = $(this).attr('href');
      var title  = encodeURIComponent($(this).attr('title'));
      window.open('http://twitter.com/share?url=' + loc + '&text=' + title + '&', 'twitterwindow', 'height=450, width=550, top='+($(window).height()/2 - 225) +', left='+$(window).width()/2 +', toolbar=0, location=0, menubar=0, directories=0, scrollbars=0');
    });
});




